import React from 'react';
import './Header.css';

function Header() {
  return (
    <div className='prequal--web--container-header prequal--web--header-order'>
      <div>Pre-Qualify for Auto Financing in 5 Minutes</div>
      <div className='prequal--web--subtext'>No SSN required. No impact on your credit score. No obligation.</div>
    </div>
  );
}

export default Header;
